import React, { useState, useEffect } from 'react';
import { db } from '../firebase/Firebase'; // Import your Firebase config
import { collection, getDocs } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

const Admin = () => {
    const [blogs, setBlogs] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        // Fetch blogs from Firebase Firestore
        const fetchBlogs = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, 'blogs'));
                const blogsList = querySnapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                setBlogs(blogsList);
            } catch (error) {
                console.error('Error fetching blogs:', error);
            }
        };

        fetchBlogs();
    }, []);

    const handleAddBlog = () => {
        navigate('/create-blog'); // Redirect to create-blog page
    };

    return (
        <div style={{ padding: '20px', backgroundColor: '#121212', color: '#fff' }}>
            <h1>Admin Panel</h1>
            <h2>Blogs</h2>
            {blogs.length > 0 ? (
                <div>
                    <ul>
                        {blogs.map((blog) => (
                            <li key={blog.id}>
                                <h3>{blog.title}</h3>
                                <p>{blog.content.substring(0, 100)}...</p>
                                <img src={blog.imageUrl} alt={blog.title} style={{ width: '200px', height: 'auto' }} />
                            </li>
                        ))}
                    </ul>
                </div>
            ) : (
                <div>
                    <p>No blogs found.</p>
                    <button onClick={handleAddBlog}>Add Blog</button>
                </div>
            )}
        </div>
    );
};

export default Admin;
